import React, { Component } from 'react';
import { reduxForm } from 'redux-form';
import {FormattedHTMLMessage} from 'react-intl';

import withAuthControl from '../auth/Auth.js';
import TopScrolleable from './TopScrolleable.js'

import Section from './Section.js'
import RequiredDocForm from './RequiredDocForm';
import CustomSpinner from './CustomSpinner';
import TextWithLine from './TextWithLine';

class Documents extends Component {

    constructor(props) {
        super(props);
        this.state = {
            requiredDocuments: {
                check_stub_1: false,
                check_stub_2: false,
                check_stub_3: false,
                service_bill: false,
                cbu: false,
                debit_card: false,
            }
        };
        this.updateDocumentStatus = this.updateDocumentStatus.bind(this);
    }

    updateDocumentStatus(documentType){
        let newState = {...this.state};
        newState.requiredDocuments[documentType] = true;
        this.setState({...newState});
    }


    render() {
        const { handleSubmit, submitting, error } = this.props;
        const { requiredDocuments:{ check_stub_1, check_stub_2, check_stub_3, service_bill, cbu, debit_card } } = this.state;

        return (
            <Section className="intro_form">
                <div className="row">
                    <div className="pd-content-left col-md-5 col-lg-5 text-center">
                        <img alt="Logo" className="center-block intro_logo" src={require(`../assets/${process.env.PAGE}/img/logo-h-blanco.png`)}/>
                        <FormattedHTMLMessage id="app.step_documents" description="Sms info"/>
                        <FormattedHTMLMessage id="app.whatsapp_timetable" description="Wp timetable"/>
                    </div>
                    <div className="pd-content-right col-sm-12 col-md-7 col-lg-7">
                        <form  className="pvc-form" onSubmit={handleSubmit(this.props.getStep)}>
                        {this.props.isLoading && <CustomSpinner message='Estamos analizando su solicitud. Por favor espere...' /> }
                            <div className="row">
                                <div className="col-sm-12 col-md-12 col-lg-12">
                                    <TextWithLine value={'Bono de sueldo de los últimos 3 meses'}/>
                                    <RequiredDocForm
                                        label={'Recibo de sueldo 1'}
                                        documentType={'check_stub_1'}
                                        maxSize={10000000}
                                        fileTypes={['image/heic', 'image/heif', 'image/jpeg', 'image/jpg', 'image/png', 'application/pdf']}
                                        onUpdateStatus={this.updateDocumentStatus}/>
                                    <RequiredDocForm
                                        label={'Recibo de sueldo 2'}
                                        documentType={'check_stub_2'}
                                        maxSize={10000000}
                                        fileTypes={['image/heic', 'image/heif', 'image/jpeg', 'image/jpg', 'image/png', 'application/pdf']}
                                        onUpdateStatus={this.updateDocumentStatus}/>
                                    <RequiredDocForm
                                        label={'Recibo de sueldo 3'}
                                        documentType={'check_stub_3'}
                                        maxSize={10000000}
                                        fileTypes={['image/heic', 'image/heif', 'image/jpeg', 'image/jpg', 'image/png', 'application/pdf']}
                                        onUpdateStatus={this.updateDocumentStatus}/>
                                </div>
                            </div>
                            <div className="row">
                                <div className="col-sm-12 col-md-12 col-lg-12">
                                    <TextWithLine value={'Servicio, comprobante y tarjeta'}/>
                                    <RequiredDocForm
                                        label={'Servicio a tu Nombre'}
                                        documentType={'service_bill'}
                                        maxSize={10000000}
                                        fileTypes={['image/heic', 'image/heif', 'image/jpeg', 'image/jpg', 'image/png', 'application/pdf']}
                                        onUpdateStatus={this.updateDocumentStatus}/>
                                    <RequiredDocForm
                                        label={'Comprobante CBU (Firmado)'}
                                        documentType={'cbu'}
                                        maxSize={10000000}
                                        fileTypes={['image/heic', 'image/heif', 'image/jpeg', 'image/jpg', 'image/png', 'application/pdf']}
                                        onUpdateStatus={this.updateDocumentStatus}/>
                                    <RequiredDocForm
                                        label={'Tarjeta Débito (Frente)'}
                                        documentType={'debit_card'}
                                        maxSize={10000000}
                                        fileTypes={['image/heic', 'image/heif', 'image/jpeg', 'image/jpg', 'image/png', 'application/pdf']}
                                        onUpdateStatus={this.updateDocumentStatus}/>
                                </div>
                            </div>
                            <div className="row">
                                <div className="col-sm-12 col-md-12 col-lg-12 text-center">
                                    <button
                                        type="submit"
                                        className="btn btn-warning btn-lg pd-button pd-form"
                                        disabled={!(check_stub_1 &&
                                                    check_stub_2 &&
                                                    check_stub_3 &&
                                                    service_bill &&
                                                    cbu &&
                                                    debit_card)}
                                    >
                                            Seguir
                                    </button>
                                </div>
                            </div>
                        </form>
                    </div>
                </div>
            </Section>
        );
    }
}

Documents.contextTypes = {
    intl: React.PropTypes.object.isRequired
}

Documents = TopScrolleable(Documents);

Documents = reduxForm({
    form: 'Documents', // a unique name for this form
})(Documents);

Documents = withAuthControl(Documents);

export default Documents;


/** WEBPACK FOOTER **
 ** ./src/components/Documents.js
 **/